import { useState, useEffect } from "react";
import {
  ChevronDownSolid,
  FilterOutline,
  SearchSolid,
} from "@graywolfai/react-heroicons";
import { Button, FormField, Loading } from "../../../Components";
import useSWR, { mutate } from "swr";
import apiHelper from "../../../Helpers/apiHelper";
import SalesPeopleSelect from "../Shared/SalesPeopleSelect";

import ContactCard from "../Shared/ContactCard";

import Filters from "../Shared/Filters";

function Assign({ normalize }) {
  const [isVisible, setVisible] = useState(false);
  const [selectedArray, setSelected] = useState([]);
  const [salesPeople, setSalesPeople] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [cacheFilters, setCacheFilters] = useState({
    assigned: 'all',
    text: '',
    salesEmail: ''
  });
  const [contacts, setContacts] = useState([]);

  const loadData = async() => {
    setIsLoading(true);
    const refreshedContactsData = await apiHelper(
      "/api/v1/admin/user/contact", "get", { view: "assignments" }
    );

    setContacts(normalize(refreshedContactsData.data.data.users));
    setIsLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  const { data: salesData } = useSWR("/api/v1/admin/user?role=sale", apiHelper);
  useEffect(() => {
    if (salesData && salesData.httpStatus === 200) {
      setSalesPeople(salesData.data.data.users);
    }
  }, [salesData]);

  const handleCardSelector = (id) => {
    if (selectedArray.includes(id)) {
      setSelected(selectedArray.filter((item) => item !== id));
    } else {
      setSelected(selectedArray.concat(id));
    }
  };

  const onFilter = async (assigned, text, salesEmail) => {
    setIsLoading(true);
    
    const refreshedContactsData = await apiHelper(
      "/api/v1/admin/user/contact",
      "get",
      {
        search: text,
        view: "assignments",
        assignmentStatus:
          assigned === "all" || assigned === "unassigned" ? 
            assigned :
            salesEmail,
      }
    );
    setContacts(normalize(refreshedContactsData.data.data.users));
    setIsLoading(false);
  };

  const handleAssignSales = async(salesId) => {
    setVisible(!isVisible);
    setIsLoading(true);

    for(let item of selectedArray) {
      await apiHelper(
        "/api/v1/admin/user/contact/" + item,
        "post", {
          operation: 'assign',
          payload: salesId
        }
      );
    }

    await loadData();

    setIsLoading(false);
  };

  return (
    <>
      {/* barra dei filtri da mobile */}
      <div className="contacts__filters-mobile">
        <Button type="default-button" text="Filter by">
          <FilterOutline className="light-icon ml-2" />
        </Button>
        <FormField
          className="flex-grow"
          withLabel="0"
          type="text"
          name="linesearch"
          placeholder="Search contacts...">
          <SearchSolid className="mid-icon"></SearchSolid>
        </FormField>
      </div>

      {/* barra dei filtri da desktop */}
      <Filters
        assignedFilterShown={true}
        salesPeople={salesPeople}
        selectedArray={selectedArray}
        onFilter={onFilter}
      />

      <div
        className={
          selectedArray.length !== 0
            ? "flex visible-true"
            : "flex visible-false"
        }>
        <div className="relative">
          <Button
            type="muted-button"
            onClick={() => setVisible(!isVisible)}
            text="Assign selected to">
            <ChevronDownSolid className="light-icon" />
          </Button>
          <ul className={`dropdown__container dropdown__container-white visible-${isVisible}`}>
            {salesPeople.map((person) => {
              return (
                <li key={person.id}>
                  <a
                    href={"#person" + person.id}
                    onClick={() => {
                      handleAssignSales(person.id);
                    }}>
                    {person.name}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      {/* elenco card di contatti */}
      {isLoading ? (
        <Loading></Loading>
      ) : (
        <div className="contacts__cardgrid">
          {contacts.map((contact) => {
            let meta = [
              { label: "Company name", value: contact.company, key: `company-${contact.id}` },
              { label: "Country", value: contact.country, key: `country-${contact.id}` },
              { label: "Registration date", value: contact.registrationDate, key: `registrationDate-${contact.id}` },
              { label: "Access level", value: contact.accessLevel, key: `accessLevel-${contact.id}` },
              { label: "Assigned to", value: contact.AssignedTo, key: `AssignedTo-${contact.id}` },
            ];
            return (
              <ContactCard
                key={contact.id}
                onClick={() => handleCardSelector(contact.id)}
                className={
                  selectedArray.includes(contact.id)
                    ? "contacts__card-selected"
                    : ""
                }
                fname={contact.fname}
                lname={contact.lname}
                email={contact.email}
                meta={meta}
              />
            );
          })}
        </div>
      )}

      {/* pannello di assegnazione agente commerciale a contatti selezionati - solo mobile */}
      <div
        className={
          selectedArray.length !== 0
            ? "contacts__assignpanel contacts__assignpanel-visible"
            : "contacts__assignpanel"
        }>
        <div className="field__container flex-grow">
          <SalesPeopleSelect withLabel selected={0} options={salesPeople} />
        </div>
        <Button
          type="default-button"
          text="Apply"
          onClick={() => setSelected([])}
        />
      </div>
    </>
  );
}

export default Assign;
